import { useMsal } from "@azure/msal-react";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useNotification } from "../../features/lazertrader/contexts/notifications";
import { setStartWithoutExchange } from "../../features/lazertrader/lazerApi";

/**
 * Sets or clears the JEPX container's `startwithoutexchange` variable, so the
 * connector can be brought up where the dedicated line to JEPX is not reachable.
 *
 * Hidden in production by its caller: this decides whether a trading process
 * talks to the venue at all.
 *
 * Both entries are blind writes. Nothing reports the variable back, so neither
 * this component nor anything behind it knows the current value, and no entry is
 * ever shown as the active one. Picking the value the container already holds is
 * harmless; it writes the same thing again.
 */
const StartWithoutExchangeMenu = () => {
  const msal = useMsal();
  const { addNotification } = useNotification();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const send = async (withoutExchange: boolean) => {
    setAnchor(null);
    try {
      await setStartWithoutExchange(msal, withoutExchange);
      addNotification(
        withoutExchange
          ? "JEPX will start without the exchange next time it starts"
          : "JEPX will connect to the exchange next time it starts",
        "success"
      );
    } catch (error) {
      addNotification(error + "", "error");
    }
  };

  return (
    <>
      <Button
        sx={{ fontSize: "12px" }}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        MANAGE
      </Button>
      <Menu
        anchorEl={anchor}
        open={anchor !== null}
        onClose={() => setAnchor(null)}
      >
        <MenuItem onClick={() => void send(true)}>Without exchange</MenuItem>
        <MenuItem onClick={() => void send(false)}>With exchange</MenuItem>
      </Menu>
    </>
  );
};

export { StartWithoutExchangeMenu };
